import { TreatmentPlanAppointment } from "../services/treatmentPlanService";
import { isBundleStep } from "./treatmentPlanAppointmentUtils";

type TreatmentPlanStep = TreatmentPlanAppointment["steps"][0];

export function getAppointmentFee(appointment: TreatmentPlanAppointment): number {
  if (appointment.totalFee != null) {
    return appointment.totalFee;
  }
  let total = 0;
  appointment.steps.forEach((step) => {
    total += getProcedureFee(step);
  });
  return total;
}

export function getAppointmentDuration(
  appointment: TreatmentPlanAppointment,
): string {
  if (appointment.totalDurationMinutes != null) {
    return `${appointment.totalDurationMinutes} min`;
  }
  let totalMinutes = 0;
  appointment.steps.forEach((step) => {
    totalMinutes += step.durationMinutes ?? 20;
  });
  return `${totalMinutes} min`;
}

export function getProcedureFee(step: TreatmentPlanStep): number {
  if (step.fee != null) {
    return step.fee;
  }
  // A bundle costs the Custom Procedure fee — summing its member codes would
  // overstate it, which is the very defect behind OP-665.
  if (isBundleStep(step.customProcedureId)) {
    return 0;
  }
  return step.codeSuggestions.reduce(
    (sum, code) => sum + (code.defaultFee || 0),
    0,
  );
}

export function getOptionLabel(
  conditionalPath: string | null | undefined,
): string | null {
  if (!conditionalPath || conditionalPath.trim() === "") {
    return null;
  }
  const rawPath = conditionalPath.trim();
  return rawPath.toLowerCase().startsWith("option")
    ? rawPath.replace(/^option\s*/i, "")
    : rawPath;
}

/** Procedure / appointment fee display — whole dollars only (no cents). */
export function formatFeeWithoutCents(fee: number): string {
  return Math.round(fee).toLocaleString("en-US", {
    maximumFractionDigits: 0,
  });
}

/** Total fee / Total Care Cost footer — always show cents. */
export function formatTotalFeeWithCents(fee: number): string {
  return fee.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
